import initState from "./initState";

import * as types from "store/types";
import { updateObject, deepClone } from "utils";

function fetchActivityLogsStart(state) {
  return updateObject(state, { loading: true });
}

function fetchActivityLogsSuccess(state, action) {
  action.logs.map(log => {
    const date = new Date(log.date.replace(/([+-]\d\d)(\d\d)$/, "$1:$2"));
    log.date = date.getTime() / 1000;
    return log;
  });

  return updateObject(state, {
    loading: false,
    list: action.logs
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_ACTIVITY_LOGS_START:
      return fetchActivityLogsStart(state, action);
    case types.FETCH_ACTIVITY_LOGS_SUCCESS:
      return fetchActivityLogsSuccess(state, action);
    default:
      return state;
  }
}

export default reducer;
